import React, { useContext } from 'react';
import { ExplorerContext } from '../../../application/config';
import {
	TrailFactory,
	TrailQuery,
} from '../../../models/factories/TrailFactory';
import TrailBookmarks from '../../Catalogue/Bookmarks/BookmarkLists/TrailBookmarks';
import NoResults from './NoResults';
import { useAppSelector } from '../../../state/hooks';
import { selectPrefs } from '../../../state/selectors';
import { shallowEqual } from 'react-redux';
import {
	filterTrailsByAccessibility,
	sortTrailsByPreferences,
} from '../../../models/helpers/preferenceRanking';

type ResultProps = {
	term: string;
};

const TrailResults: React.FC<ResultProps> = ({ term }) => {
	const AppData = useContext(ExplorerContext);
	const userPrefs = useAppSelector(selectPrefs, shallowEqual);
	const query: TrailQuery = {
		filter: {
			title: term,
		},
	};
	const all_trails = TrailFactory.filter(
		AppData.features?.all_trails ?? TrailFactory.getEmpty(),
		query,
	);
	const results = TrailFactory.filter(all_trails, query);
	const prioritisedTrails = sortTrailsByPreferences(
		filterTrailsByAccessibility([...results.trails], userPrefs),
		userPrefs,
	);

	return (
		<>
			{prioritisedTrails.length > 0 && (
				<TrailBookmarks trails={prioritisedTrails} />
			)}
			{prioritisedTrails.length === 0 && <NoResults />}
		</>
	);
};

export default TrailResults;
